import { FC } from 'react'

import SeparatorVertical from 'src/components/ui/atoms/SeparatorVertical'
import componentColorVariants from 'src/components/ui/variants/componentColorVariants'
import { cn } from 'src/lib/cn'
import ComponentColor from 'src/types/ItemColor'
import { icFirstFn } from 'src/utils/textUtils'

export interface PageHeaderTitleProps {
  title: string
  subTitle: string
  dataPendo?: string
  componentColor: ComponentColor
}

const PageHeaderTitle: FC<PageHeaderTitleProps> = ({
  title,
  subTitle,
  dataPendo,
  componentColor,
}) => {
  return (
    <div
      className="ml-2.5 flex items-center gap-2 text-[22px] font-medium"
      data-testid="page-header-title"
    >
      <span className="text-bay-of-many text-nowrap" data-testid="header-product-title">
        {title}
      </span>
      {subTitle && <SeparatorVertical withoutMargin className="!h-4" />}
      <span
        data-testid="header-product-title-dashboard-name"
        data-pendo={dataPendo}
        className={cn(
          'text-nowrap',
          componentColorVariants({
            text: componentColor,
          }),
        )}
      >
        {icFirstFn(subTitle)}
      </span>
    </div>
  )
}

export default PageHeaderTitle
